<div class="filter-users">
  <div
    class="filter-users__dropdown vox-dropdown-input"
    ngbDropdown>
    <button
      type="button"
      class="filter-users__dropdown-toggle"
      ngbDropdownToggle>
      <span
        class="filter-users__dropdown-toggle-text"
        [title]="selectedUser?.first_name + ' ' + selectedUser?.last_name"
        *ngIf="selectedUser">
        {{ selectedUser?.first_name }} {{ selectedUser?.last_name }}
      </span>
      <span
        class="filter-users__dropdown-toggle-text"
        [title]="'events.company-call-history.filters.options.all-users' | Translate"
        *ngIf="!selectedUser">
        {{ "events.company-call-history.filters.options.all-users" | Translate }}
      </span>
    </button>
    <ul
      class="filter-users__dropdown-menu"
      ngbDropdownMenu>
      <li
        class="filter-users__dropdown-item"
        ngbDropdownItem
        (click)="changeUser(null)">
        <span
          class="filter-users__dropdown-item-text"
          [title]="'events.company-call-history.filters.options.all-users' | Translate">
          {{ "events.company-call-history.filters.options.all-users" | Translate }}
        </span>
      </li>
      <li
        class="filter-users__dropdown-item"
        ngbDropdownItem
        (click)="changeUser(user)"
        *ngFor="let user of users">
        <span
          class="filter-users__dropdown-item-text"
          [title]="user.first_name + ' ' + user.last_name">
          {{ user.first_name }} {{ user.last_name }}
        </span>
      </li>
    </ul>
  </div>
</div>
